<template>
  <button
    type="button"
    class="group px-4 py-2 focus:outline-none w-full text-left text-gray-700 hover:bg-gray-100 hover:text-gray-900"
    role="menuitem"
    @click="$emit('select', thirdPartyService.id)"
  >
    <h3 class="text-sm font-medium text-gray-800">
      {{ label }}
    </h3>
    <p v-if="secondaryText" class="text-xs text-gray-600">
      {{ secondaryText }}
    </p>
  </button>
</template>

<script>
export default {
  props: {
    thirdPartyService: {
      type: Object,
      required: true,
    },
    current: Boolean,
  },
  computed: {
    label() {
      if (this.thirdPartyService?.config?.name) {
        return this.thirdPartyService.config.name;
      }

      return `${this.thirdPartyService.service} ${this.thirdPartyService.channel}`;
    },
    secondaryText() {
      if (this.thirdPartyService.service === 'nexmo') {
        return this.thirdPartyService.config?.smsFrom;
      }

      if (this.thirdPartyService.service === 'smtp') {
        return this.thirdPartyService.config?.fromEmail;
      }

      return '';
    },
  },
};
</script>
